"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _exportAnalytics = _interopRequireDefault(require("../../control/modules/Exports/export-analytics"));

var _ExportAnalyticsModal = _interopRequireDefault(require("../../control/modules/Exports/export-analytics/ExportAnalyticsModal"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _exportAnalyticsApi = require("../../control/modules/Exports/export-analytics/export-analytics-api");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AnalyticsExport = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AnalyticsExport, _Component);

  var _super = _createSuper(AnalyticsExport);

  function AnalyticsExport() {
    var _this;

    (0, _classCallCheck2.default)(this, AnalyticsExport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "exportAnalyticsRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isModalOpen: false,
      isSubmitting: false,
      notification: undefined,
      notificationKey: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      _publish.default.trackEvent('userevent', {
        type: 'Exports V2 Load',
        event_source: 'control',
        boundedContext: 'Analytics',
        entity: 'exports-v2',
        elementName: 'Exports V2',
        eventDetail: 'analytics.exports-v2.exportsV2Loaded',
        trackType: 'load'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openModal", function () {
      _this.setState({
        isModalOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeModal", function () {
      _this.setState({
        isModalOpen: false,
        isSubmitting: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clearNotification", function () {
      _this.setState({
        notification: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleNotification", function (variant, text) {
      _this.setState(function (prevState) {
        return {
          notification: {
            variant: variant,
            text: text
          },
          notificationKey: prevState.notificationKey + 1
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchNewV1Export", function () {
      var delay = 2000; // 2 seconds delay

      setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.exportAnalyticsRef.current) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this.exportAnalyticsRef.current.silentRefreshAfterExport();

              case 5:
                _context.next = 9;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7]]);
      })), delay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleModalSave", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(payload) {
        var newExport, message;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.setState({
                  isSubmitting: true
                });

                _context2.prev = 1;
                _context2.next = 4;
                return (0, _exportAnalyticsApi.requestExport)(payload);

              case 4:
                newExport = _context2.sent;

                _this.setState(function (prevState) {
                  return {
                    notification: {
                      variant: 'success',
                      text: 'Export requested. You can track progress in the Export Table.'
                    },
                    isSubmitting: false,
                    isModalOpen: false,
                    notificationKey: prevState.notificationKey + 1
                  };
                }); // Track "All time" export event


                if (payload.allTimeData) {
                  _publish.default.trackEvent('userevent', {
                    type: 'All Time Clicked',
                    event_source: 'control',
                    boundedContext: 'Analytics',
                    entity: 'exports-v2',
                    elementName: 'Date Picker All Time',
                    eventDetail: 'analytics.exports-v2.datePickerAllTimeClicked',
                    trackType: 'click'
                  });
                } // Check the actual request parameter to determine V1 vs V2


                if (_this.exportAnalyticsRef.current) {
                  if (payload.useLegacyExport) {
                    // V1: Legacy export (toggle ON) - fetch after delay
                    _this.fetchNewV1Export();
                  } else if (newExport) {
                    // V2: New export (toggle OFF) - add data immediately
                    _this.exportAnalyticsRef.current.addNewExport(newExport);
                  }
                }

                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);
                message = _context2.t0 instanceof Error ? _context2.t0.message : "Export couldn't be generated. Please try again later.";

                _this.setState(function (prevState) {
                  return {
                    notification: {
                      variant: 'error',
                      text: message
                    },
                    isSubmitting: false,
                    notificationKey: prevState.notificationKey + 1
                  };
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 10]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleModalSaveScheduled", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(payload) {
        var _this$exportAnalytics, message;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({
                  isSubmitting: true
                });

                _context3.prev = 1;
                _context3.next = 4;
                return (0, _exportAnalyticsApi.createScheduledExport)(payload);

              case 4:
                _this.setState(function (prevState) {
                  return {
                    notification: {
                      variant: 'success',
                      text: 'Scheduled export created successfully.'
                    },
                    isSubmitting: false,
                    isModalOpen: false,
                    notificationKey: prevState.notificationKey + 1
                  };
                }); // Refresh the scheduled exports table


                (_this$exportAnalytics = _this.exportAnalyticsRef.current) === null || _this$exportAnalytics === void 0 ? void 0 : _this$exportAnalytics.refreshScheduledExports();
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                message = _context3.t0 instanceof Error ? _context3.t0.message : 'Failed to create scheduled export. Please try again later.';

                _this.setState(function (prevState) {
                  return {
                    notification: {
                      variant: 'error',
                      text: message
                    },
                    isSubmitting: false,
                    notificationKey: prevState.notificationKey + 1
                  };
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(AnalyticsExport, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isModalOpen = _this$state.isModalOpen,
          isSubmitting = _this$state.isSubmitting,
          notification = _this$state.notification,
          notificationKey = _this$state.notificationKey;
      var customButtons = [{
        title: 'Request Export',
        variant: 'brand',
        action: this.openModal,
        newStyle: true,
        size: 'medium'
      }];
      return (0, _preact.h)("div", {
        className: "analytics-export-dashboard"
      }, notification ? (0, _preact.h)(_AlertComponent.default, {
        key: notificationKey,
        messageType: notification.variant,
        message: notification.text,
        sticky: true,
        renderHTML: true,
        onClose: this.clearNotification,
        isVisibleFor: 5000
      }) : null, (0, _preact.h)(_header.default, {
        title: "Export",
        disableCancelButton: true,
        disableSaveButton: true,
        customButtons: customButtons
      }), (0, _preact.h)(_exportAnalytics.default, {
        ref: this.exportAnalyticsRef,
        onNotification: this.handleNotification
      }), (0, _preact.h)(_ExportAnalyticsModal.default, {
        isOpen: isModalOpen,
        onClose: this.closeModal,
        onSave: this.handleModalSave,
        onSaveScheduled: this.handleModalSaveScheduled,
        isSubmitting: isSubmitting
      }));
    }
  }]);
  return AnalyticsExport;
}(_preact.Component);

var _default = AnalyticsExport;
exports.default = _default;